export default "__VITE_ASSET__3ff8df93__"